// All the names are synced with this document:
// https://docs.google.com/document/d/1qat7pGpBG9cExT8_hLuxHVbwVGX-M-m_a33nx7XipVc/edit?usp=sharing

import clickDownloadAndShareOnMinisite from './functions/clickDownloadAndShareOnMinisite';
import clickNextOnAQuestion from './functions/clickNextOnAQuestion';
import downloadPdfFromPopup from './functions/downloadPdfFromPopup';
import userIsMovedToTheNextSection from './functions/userIsMovedToTheNextSection';
import quickSignUpBtnViewed from './functions/quickSignUpBtnViewed';
import quickSignUpLoginPageViewed from './functions/quickSignUpLoginPageViewed';
import quickSignUpLoginSucceed from './functions/quickSignUpLoginSucceed';
import quickSignUpStarted from './functions/quickSignUpStarted';
import quickSignUpSucceed from './functions/quickSignUpSucceed';
import { sendFbEventToConversionApi } from './functions/sendFbEventToConversionApi';

export default {
  quickSignUpSucceed,
  quickSignUpStarted,
  quickSignUpLoginSucceed,
  quickSignUpLoginPageViewed,
  quickSignUpBtnViewed,
  clickDownloadAndShareOnMinisite,
  clickNextOnAQuestion,
  downloadPdfFromPopup,
  userIsMovedToTheNextSection,
  sendFbEventToConversionApi,
};
